import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getTemplatesRpc } from '../../../../__generated__/chirp/com/hubspot/custom/enrichment/rpc/client/SmartPropertyTemplateService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export async function fetchTemplates() {
  const companyTemplates = await rpcClient.call(getTemplatesRpc, {
    request: {
      objectTypeId: '0-2'
    }
  });
  const contactTemplates = await rpcClient.call(getTemplatesRpc, {
    request: {
      objectTypeId: '0-1'
    }
  });
  return [...companyTemplates.templates, ...contactTemplates.templates];
}